import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';
import { CheckCircleIcon, ErrorIcon, InformationIcon, WarningIcon } from '@slal/ui/icons';
import { TargetIcon } from '~/components';

export const ChartWrapper = styled.div`
    min-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    transition: all 0.25s ease-in-out;
`;

export const ChartContainer = styled.div`
    position: relative;
    width: 103px;
    height: 167px;
`;

export const JarStack = styled.rect.attrs<{ color: string; height?: number; y?: number }>(({ height, y }) => ({
    height: height,
    y: y,
}))<{ color: string }>`
    fill: ${({ color }) => color};
    width: 100%;
`;

export const LabelWrapper = styled.div`
    background: transparent;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
`;

export const Line = styled.div<{ xPos: number; yPos: number; right?: boolean }>`
    z-index: 1;
    position: absolute;
    border-top: 2px dashed ${({ theme }) => theme.colors.neutral__dark__00};
    width: 100%;
    height: 2px;
    top: ${({ yPos }) => yPos}px;
    left: 0px;
    transition: top 0.25s ease-in-out;
`;

export const Target = styled(TargetIcon)<{ xPos: number; yPos: number }>`
    bottom: -16px;
    z-index: 2;
    position: absolute;
    top: ${({ yPos }) => yPos - 16}px;
    right: -38px;
    transition: top 0.25s ease-in-out;
`;

export const LegendWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    gap: 6px;
    margin-top: 0;
    ${breakpointUp.md`
        max-width: 300px
    `}
`;

export const LegendItem = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    transition: all 0.25s ease-in-out;
    p {
        font-size: 18px;
    }
`;

export const LegendLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    p {
        font-size: 18px;
    }
`;

export const LegendColor = styled.span<{ color: string }>`
    width: 20px;
    height: 20px;
    background-color: ${({ color }) => color};
    margin-right: 10px;
    border-radius: 3px;
`;

export const Label = styled.div<{ xPos: number; yPos: number; right?: boolean; targetReached?: boolean }>`
    position: absolute;
    min-width: auto;
    border-left: solid 2px black;
    border-color: ${({ theme }) => theme.colors.neutral__dark__30};
    background-color: ${({ theme }) => theme.colors.neutral__light__20};
    padding: 8px 12px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: translate(111px, -50%);
    p {
        text-align: center;
        strong {
            font-size: 16px;
        }
    }
    top: ${({ yPos }) => yPos}px;
    left: ${({ right }) => (right ? '100%' : 0)};
    transition: all 0.25s ease-in-out;
    &::before {
        content: '';
        position: absolute;
        left: -7px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-right: 6px solid
            ${({ targetReached, theme }) => (targetReached ? theme.colors.green__80 : theme.colors.neutral__dark__20)};
    }
`;

export const IncomePotHeadingWrapper = styled.div`
    text-align: center;
`;

export const StyledDangerIcon = styled(ErrorIcon)`
    min-width: 24px;
    min-height: 24px;
    color: ${({ theme: { colors } }) => colors.red__80};
`;

export const StyledInformationIcon = styled(InformationIcon)`
    min-width: 24px;
    min-height: 24px;
    color: ${({ theme: { colors } }) => colors.blue__secondary__80};
`;

export const StyledSuccessIcon = styled(CheckCircleIcon)`
    min-width: 24px;
    min-height: 24px;
    color: ${({ theme: { colors } }) => colors.green__80};
`;

export const StyledWarningIcon = styled(WarningIcon)`
    min-width: 24px;
    min-height: 24px;
    color: ${({ theme: { colors } }) => colors.orange__80};
`;

export const IncomePotsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
